/**
 * Calcula o módulo (resto da divisão) a mod m
 * @param {number} a O dividendo
 * @param {number} n O divisor
 * @returns {number} O resto da divisão
 */
export default function mod(a: number, n: number): number {
  return ((a % n) + n) % n
}
